import { defineApi } from 'services/api/defineApi';

// The AP (Accounts Payable) API — the default client. Replaces the former
// singleton apiClient + getConfig.
export const apApi = defineApi('ap');

// The payment API — different baseURL + headers, configured at boot by
// paymentApiClientInitializer.
export const payApi = defineApi('pay');
